import React from 'react';
import './ActivitiesContribution.css';

const ActivitiesContributionItem = (props) => {
  const setCategoryName = (category) => {
    if(props.categories.length){
      let discipline = props.categories.find(i => i.name === category);
      return (discipline.displayName);
    }
  }
  const setIcon = (category) => {
    if(props.categories.length){
      let discipline = props.categories.find(i => i.name === category);
      return (discipline.icon);
    }
  }
  const setProgressBarWidth = (progress) => {
    return {width: progress + '%'}
  }

  return(
    <li className="ActivitiesContribution-item">
      <div className="ActivitiesContribution-item__category">
        <img src={setIcon(props.category)} alt={props.category} className="ActivitiesContribution-item__category__icon" />
        {setCategoryName(props.category)}
      </div>
      <div className="ActivitiesContribution-item__progress">
        <div className="ActivitiesContribution-item__progressBar" style={setProgressBarWidth(props.progress)}></div>
      </div>
      <div className="ActivitiesContribution-item__stats">
       {props.contribution}%
      </div>
    </li>
  )
}

const ActivitiesContribution = (props) =>{

  const categoryContributionInPercents = (points) => {
    const totalActivitiesPoints = props.pointsAndMoney.points;
    return Math.round(points * 100 / totalActivitiesPoints );
  }

  const progressBar = (points) =>{
    const maxCategoryPoints = props.categoriesResults[0].totalPoints;
    return(points * 100 / maxCategoryPoints);
  }

  return (
    <div className="ActivitiesContribution">
      <ul className="ActivitiesContribution-list">
        {props.categoriesResults.map( (i, index) => <ActivitiesContributionItem
          key={index}
          category={i.discipline}
          categories={props.categories}
          progress={progressBar(i.totalPoints)}
          contribution={categoryContributionInPercents(i.totalPoints)}
          />
        )}
      </ul>
    </div>
  )
}

export default ActivitiesContribution;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/ActivitiesContribution/ActivitiesContribution.js